import React from "react";
import {Redirect, Route} from "react-router-dom";

export const PrivateRoute = ({
                                 isAuthenticated,
                                 component: Component,
                                 ...rest
                             }) => {
    return <Route
        {...rest}
        component={(props) => {
            // Check authentication on each render
            let access = null;
            try {
                access = JSON.parse(localStorage.getItem("access"));
            } catch (e) {
                access = null;
            }
            return access?.token ? <Component {...props} /> : <Redirect to="/"/>
        }}
    />
}
export default (PrivateRoute);
